import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/service/api-request.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ExcelService } from 'src/app/service/excel.service';
import { GetSendCommOptions, SendCommApiRequest, SendCommApiResponse, TypeTemplatesByMode, SendMailData, SendMailGetApiResponse, SendMailPostApiRequest, SendMailPostApiResponse } from '../types/send-mails';
import { GenericApiService } from 'src/app/service/generic-api-request';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  public componentName: string = 'inventory';
  public surveyReport:any = {};
  public QuotaDetails:any = [];
  public surveyDetails:any = {};
  public SurveyGetLink:any=[];
  public defaultSurveyGetLink:number = 1;
  public accessRoles:any={};
  public loginClientDetails:any = {};
  public oprationsAccessRules: any ={"showOprations":false,"upload_response":false,"upload_payment":false}
  public showMultipleLinkAccess:boolean = false;
  public  switchUserAccess:boolean = false;
  public  surveyCagsDeatils:any = {};
  public  showCagsDeatilsModal:boolean = false;
  public  showReasonListModal:boolean = false;
  public  responseStatusModalOpen:boolean = false;
  public  paymentStatusModalOpen:boolean = false;
  public responseDetails_rid:any;
  public redirectFromCompletion:boolean = false;
  public redirectFromInventory:boolean = false;
  public redirectFromCompletionSurveyDetails:any = {};
  public containers_arr:any = [];
  public copy_containers_arr = []
  public selected_container:any = {};
  public responseReportType:string = "";
  public quotaType:string = "shared";
  sendMailData: SendMailData | undefined;
  sendCommData: { comms: string[], commTemplatesMap: TypeTemplatesByMode } | undefined;






  // public showOprations:boolean=false;
  // public showMultipleContainerAccess:boolean = true;
  // public showShareInventory:boolean = true;

  constructor(
    private http: HttpClient,
    private apiRequest: ApiRequestService,
    private apiGeneric: GenericApiService,
    private route:Router,
    private activeRoute:ActivatedRoute,
    public excelService:ExcelService){
      this.accessRoles = JSON.parse(localStorage.getItem('access') || '');
      this.accessRoles = this.accessRoles.access_rules;
      this.checkMultipleLinkAccess();
      this.checkSwitchUserAccess();
      this.setClientDetails();
      if(this.accessRoles && this.accessRoles.survey)
      {
        if (this.accessRoles.survey.operations) {
          // this.showOprations=true;
          this.oprationsAccessRules.showOprations = true;
          if (this.accessRoles.survey.operations.upload_response) {
            this.oprationsAccessRules.upload_response = true;
          }
          if (this.accessRoles.survey.operations.upload_payment) {
            this.oprationsAccessRules.upload_payment = true;
          }
        }
      }
   }

   checkMultipleLinkAccess(){
    if(this.accessRoles && this.accessRoles.survey && this.accessRoles.survey.generate_links)
    {
      this.showMultipleLinkAccess = true;
    }
  }

  checkSwitchUserAccess(){
    if(this.accessRoles && this.accessRoles.header && this.accessRoles.header.switch_user){
      this.switchUserAccess = true;
    }
     

  }

  setClientDetails(){
    if(localStorage.getItem('clientDetails'))
    {
      this.loginClientDetails = localStorage.getItem('clientDetails');
      this.loginClientDetails = JSON.parse(this.loginClientDetails);
    }
  }


  
  
  submitCallback(complete : string,over_quota : string,terminate:string,error:string){
    // let headers = new HttpHeaders({
    //   'Content-Type':'application/json; charset=utf-8',
    // });
    // var httpPostOptions = {
    //   lazyUpdate:null,
    //   headers: headers,
    //   withCredentials: true
    // };

    let opt:any = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true,
      lazyUpdate:null,
      params:{},
      query:{}
    };
    let body:any = {};
    body['complete'] = complete;
    body['over_quota'] = over_quota;
    body['terminate'] = terminate;
    body['failure'] = error;

    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0)
    {
      body['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('POST', `/supply/callback`,body,opt);
    // return this.http.post<any>(environment.apiUrl + `/supply/callback`, { complete: complete, over_quota: over_quota,terminate:terminate,failure:error }, httpPostOptions)
  }



  updateCallback(complete : string,over_quota : string,terminate:string,error:string){
    // let headers = new HttpHeaders({
    //   'Content-Type':'application/json; charset=utf-8',
    // });
    // var httpPostOptions = {
    //   lazyUpdate:null,
    //   headers: headers,
    //   withCredentials: true
    // };

    let opt:any = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true,
      lazyUpdate:null,
      params:{},
      query:{}
    };
    let body:any = {};
    body['complete'] = complete;
    body['over_quota'] = over_quota;
    body['terminate'] = terminate;
    body['failure'] = error;

    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0)
    {
      body['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    // return this.http.put<any>(environment.apiUrl + `/supply/callback`, { complete: complete, over_quota: over_quota,terminate:terminate,failure:error }, httpPostOptions)
    return this.apiRequest.request('PUT', `/supply/callback`,body,opt);


  }
  // getCallbackUrl(){
  //   let headers = new HttpHeaders({
  //     'Content-Type':'application/json; charset=utf-8',
  //   });
  //   var httpPostOptions = {
  //     lazyUpdate:null,
  //     headers: headers,
  //     withCredentials: true
  //   };
  //   let opt = {};
  //   return this.http.get<any>(environment.apiUrl + `/supply/callback`, httpPostOptions)

  //   // return this.http.get<any>(`http://localhost:2108/getCallbackUrl`, httpPostOptions)
  //   //   .pipe(map(data => {
  //   //     console.log("data ==>",data)
  //   //     return data;
  //   //   }));
  // }


  getCallbackUrl(val:any){
    let opt:any = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true,
      lazyUpdate:null,
      params:{},
      query:{}
    };
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0)
    {
      opt.query['clientUUIDs'] =  val;
    }
    // opt.query['clientUUIDs'] = val;
    return this.apiRequest.request('GET', `/supply/callback`,{},opt);
  }
  getTgQuotaDetails(survey_id:any,container_id?:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    if(container_id && container_id != ''){
      opt.query['container_id'] = container_id;
    }
    return this.apiRequest.request('GET',`/survey_tg/${survey_id}`,{},opt);
    // return this.http.get<any>(environment.apiUrl + `/quota/${survey_id}`,httpPostOptions);
  }
  getQuotaDetails(survey_id:any,container_id?:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{'type':this.quotaType}};
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    if(container_id && container_id != ''){
      opt.query['container_id'] = container_id;
    }
    return this.apiRequest.request('GET',`/quota/${survey_id}`,{},opt);
  }
  getSurvayList(){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('GET','/survey',{},opt);
  }

  launcgSurvay(surveyUUid:string){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    return this.apiRequest.request('GET','/sync/ipsos/crownit/'+surveyUUid,{},opt);
  }

  getShareInventoryList(){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('GET','/inventory/share/users',{},opt);
  }


  getClientBasedSurvayList(status:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    opt.query['status'] = status;
    return this.apiRequest.request('GET','/survey',{},opt);
  }

  getSurvayDetails(survey_id:string,container_id?:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    if(container_id && container_id != ''){
      opt.query['container_id'] = container_id;
    }
    if(this.redirectFromCompletionSurveyDetails && (this.redirectFromCompletionSurveyDetails.pid || this.redirectFromCompletionSurveyDetails.rid))
    {
      if(this.redirectFromCompletionSurveyDetails.rid){
        opt.query['response_id'] = this.redirectFromCompletionSurveyDetails.rid;
      } else{
        opt.query['response_id'] = this.redirectFromCompletionSurveyDetails.pid;
      }
    }
    return this.apiRequest.request('GET','/survey/'+survey_id,{},opt);
  }

  getDownloadLinkDetails(survey_id:string,no:number){
    let opt = {};
    return this.apiRequest.request('GET',`/survey-links/${survey_id}/${no}`,{},opt);
  }


  getReasonList(){
    let opt = {};
    return this.apiRequest.request('GET','/reason-list',{},opt);
  }

  

  getCompletionReport(query:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    if (query && Object.keys(query).length) {
      opt['query'] = query.filter
    }
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length && !opt.query['clientUUIDs'])
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('GET','/reports/complete_report',{},opt);
  }

  getSurveyList(status?:string){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    let url = '/reports/surveys/'
    if (status && status != "") {
      url += status
    } 
    console.log("url is,", url);
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('GET',url,{},opt);
  }
  
  // onDownloadCompletionReport(){
  //   let opt = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
  //   withCredentials: true,
  //   params:{},
  //   query:{}};
  //   // if (query && Object.keys(query).length) {
  //   //   opt['query'] = query.filter
  //   // } 
  //   opt['query'] = {"download":true}
  //   return this.apiRequest.request('GET','/reports/complete_report_download',{},opt);
  // }

  onDownloadCompletionReport(query:any){
    let opt:any = {headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{},
    query:{}};
    opt['query'] = query
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length)
    {
      opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }
    return this.apiRequest.request('GET','/reports/complete_report_download',{},opt);
  }

  downloadLink(res:any){
    let res_obj = res.map((va:any) => ({'link':va}));
    this.excelService.exportJsonAsExcelFile(res_obj,"MultipleLink-report");
  }

  // onUploadRejection(fileBody:any){
  //   console.log("fileBody in rejection ", fileBody)
  //   let data = new FormData();
  //   let opt = {'httpOptions':{
  //     withCredentials: true
  //   }};
  //   data.append('test',"hello");
  //   data.append('file',fileBody.fileObj,fileBody.fileObj['name']);
  //   console.log("file data is ", data)
  //   // return this.apiRequest.request('POST','/v2/repo/uploadFiles',data,opt);
  // }

  // onUploadPayment(fileBody:any){
  //   console.log("fileBody in payment", fileBody)
  //   let data = new FormData();
  //   let opt = {'httpOptions':{
  //     withCredentials: true
  //   }};
  //   data.append('test',"hello");
  //   data.append('file',fileBody.fileObj,fileBody.fileObj['name']);
  //   console.log("file data is ", data)
  //   // return this.apiRequest.request('POST','/v2/repo/uploadFiles',data,opt);
  // }

  onUploadRejection(fileBody:any){
    console.log("fileBody in rejection ", fileBody)
    let opt = {'httpOptions':{
      withCredentials: true
    }};
    console.log("file data is ", fileBody)
    return this.apiRequest.request('POST','/survey/operation-update',fileBody,opt);
  }

  onUploadPayment(fileBody:any){
    console.log("fileBody in payment", fileBody)
    let opt = {'httpOptions':{
      withCredentials: true
    }};
    // console.log("file data is ", fileBody)
    return this.apiRequest.request('POST','/survey/amount-update',fileBody,opt);
  }

  getSetDirectionUrl(val:any){
    let opt:any = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true,
      lazyUpdate:null,
      params:{},
      query:{}
    };
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0)
    {
      opt.query['clientUUIDs'] =  val;
    }
    // opt.query['clientUUIDs'] = val;
    return this.apiRequest.request('GET', `/supply/callback`,{},opt);
  }


  getResponseDetails(rid:any,type:any){
    let opt:any = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true,
      lazyUpdate:null,
      params:{},
      query:{}
    };
    // if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0)
    // {
    //   opt.query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    // }
    opt.query['type'] = type;
    opt.query['report'] = this.responseReportType;
    return this.apiRequest.request('GET', `/survey/response-status/${rid}`,{},opt);
  }

  getSurveyDetailsPid(){
    return this.redirectFromCompletionSurveyDetails.pid;
  }

  getCagsDeatils(){
    let cag = this.redirectFromCompletionSurveyDetails.cags;
    let str:any = [];
    // if(cag['Age'] && cag['Age'].length > 0){
    //   cag['Age'].forEach((va:any) => str.push(va));
    // }
    // if(cag['Gender'] && cag['Gender'].length > 0){
    //   cag['Gender'].forEach((va:any) => str.push(va));
    // }
    // if(cag['City'] && cag['City'].length > 0){
    //   cag['City'].forEach((va:any) => str.push(va));
    // }
    if(Object.keys(cag).length){
      Object.keys(cag).forEach((va:any) =>
      {
        cag[va].forEach((v1:any) =>
        {
          str.push(v1);
        })
      })
    }
    return str.length > 0 ? str.join(',') : 'No Cags'
  }

  setContainers(survey:any){
    this.containers_arr = [];
    this.copy_containers_arr = [];
    if(survey.containers && survey.containers.length > 0){
      this.containers_arr = survey.containers;
      this.containers_arr.unshift({'container_name':'Container All','status':'Active','container_id':''});
      this.copy_containers_arr = this.containers_arr;
    }
  }


  selectedContainer(){
    if(this.surveyDetails.selected_container && Object.keys(this.surveyDetails.selected_container).length && this.redirectFromCompletion){
      this.selected_container = this.surveyDetails.selected_container;
    }
    else if(localStorage.getItem('selected_container')){
      let selected_container:any = localStorage.getItem('selected_container');
      selected_container = JSON.parse(selected_container);
      this.selected_container = selected_container;
    }
    else
    {
      this.selected_container = {'container_name':'Container All','status':'Active','container_id':''};
    }
  }

  getNewlyAddedSurveysWithEmails(){
    let query:any = { };
    
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0) {
      query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }

    return this.apiGeneric.get<SendMailGetApiResponse>(`/api/getMailandSurvey`,{query: query})
  }

  sendNewlyAddedSurveysMail(requestBody: SendMailPostApiRequest){
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0) {
      requestBody['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }

    return this.apiGeneric.post<SendMailPostApiResponse>(`/api/sendMail`, requestBody)
  }

  getSendSurveyComm() {
    let query:any = { };
    
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0) {
      query['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }

    return this.apiGeneric.get<GetSendCommOptions>(`/api/getSendCommParams`,{query: query})
  }

  sendSurveyComm(requestBody: SendCommApiRequest){
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0) {
      requestBody['clientUUIDs'] =  this.loginClientDetails['uuid'];
    }

    return this.apiGeneric.post<SendCommApiResponse>(`/api/sendComm`, requestBody)
  }

  isAllOrg() {
    if(this.switchUserAccess && Object.keys(this.loginClientDetails).length > 0 && this.loginClientDetails['uuid'] === "") {
      return true;
    }
    return false;
  }



}
